<ng-container [ngSwitch]="element">
  <h1 *ngSwitchCase="'h1'" [ngClass]="classes">
    <ng-content></ng-content>
  </h1>
  <h2 *ngSwitchCase="'h2'" [ngClass]="classes">
    <ng-content></ng-content>
  </h2>
  <h3 *ngSwitchCase="'h3'" [ngClass]="classes">
    <ng-content></ng-content>
  </h3>
  <h4 *ngSwitchCase="'h4'" [ngClass]="classes">
    <ng-content></ng-content>
  </h4>
  <h5 *ngSwitchCase="'h5'" [ngClass]="classes">
    <ng-content></ng-content>
  </h5>
  <h6 *ngSwitchCase="'h6'" [ngClass]="classes">
    <ng-content></ng-content>
  </h6>
  <p *ngSwitchCase="'p'" [ngClass]="classes">
    <ng-content></ng-content>
  </p>
  <span *ngSwitchCase="'span'" [ngClass]="classes">
    <ng-content></ng-content>
  </span>
</ng-container>